import { usePaymentProvider } from './use-payment-provider.hook';

export const usePaymentProviderIFrameBased = () => {
  const paymentProvider = usePaymentProvider();
  if (paymentProvider.tokenizationMechanism !== 'IFRAME') {
    throw new Error('Payment provider is not IFRAME based');
  }
  return paymentProvider;
};
